import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getOfferingBookingReplyAPI,
  saveOfferingBookingReplyAPI,
  deleteOfferingBookingReplyAPI,
} from "../../api/ecommerce/OfferingBookingReplyApi";

const unwrapReply = (data) =>
  data && Object.prototype.hasOwnProperty.call(data, "response") ? data.response : data;

const makeThunk = (name, api) => createAsyncThunk(
  `offeringBookingReply/${name}`,
  async (args, { rejectWithValue }) => {
    try {
      const response = await api(args);
      return unwrapReply(response.data);
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || "Unable to update booking reply."
      );
    }
  }
);

export const getOfferingBookingReply = makeThunk("get", getOfferingBookingReplyAPI);
export const saveOfferingBookingReply = makeThunk("save", saveOfferingBookingReplyAPI);
export const deleteOfferingBookingReply = makeThunk("delete", deleteOfferingBookingReplyAPI);

const initialEntry = () => ({ reply: null, loading: false, saving: false, deleting: false, error: null });

const slice = createSlice({
  name: "offeringBookingReply",
  initialState: { byOfferingId: {} },
  reducers: {},
  extraReducers: (builder) => {
    [
      [getOfferingBookingReply, "loading"],
      [saveOfferingBookingReply, "saving"],
      [deleteOfferingBookingReply, "deleting"],
    ].forEach(([thunk, flag]) => {
      const idOf = (action) => action.meta.arg?.offeringId ?? action.meta.arg;
      builder.addCase(thunk.pending, (state, action) => {
        const id = idOf(action);
        const entry = state.byOfferingId[id] || (state.byOfferingId[id] = initialEntry());
        entry[flag] = true;
        entry.error = null;
        entry.requestId = action.meta.requestId;
      });
      builder.addCase(thunk.fulfilled, (state, action) => {
        const entry = state.byOfferingId[idOf(action)];
        if (entry?.requestId !== action.meta.requestId) return;
        entry[flag] = false;
        entry.reply = thunk === deleteOfferingBookingReply ? null
          : thunk === saveOfferingBookingReply ? action.payload ?? action.meta.arg.request
          : action.payload;
      });
      builder.addCase(thunk.rejected, (state, action) => {
        const entry = state.byOfferingId[idOf(action)];
        if (entry?.requestId !== action.meta.requestId) return;
        entry[flag] = false;
        entry.error = action.payload || action.error.message;
      });
    });
  },
});

export default slice.reducer;
